const Loader = () => {
  return (
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-red-500 border-opacity-50"></div>
  );
};
export default Loader;
